import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import classNames from 'classnames';
import { TrackingConstant } from 'client/tracking/constant';

export const EmailButton = ({
  ariaLabel = 'email',
  toggleLeadFormDrawer = null,
  btnClass = '',
  btnColor = '',
  icon = '',
  iconClass = '',
  titleClass = '',
  title = '',
}) => {
  return (
    <Button
      aria-label={ariaLabel}
      size="lg"
      color={btnColor}
      className={btnClass}
      onClick={toggleLeadFormDrawer}
      data-tracking-id={TrackingConstant.VIEW_PRICING_DETAILS}
      data-tracking-value="email"
      data-test="email-button"
    >
      {icon && <i className={classNames(icon, iconClass)} aria-hidden />}
      {title && <span className={titleClass}>{title}</span>}
    </Button>
  );
};

EmailButton.propTypes = {
  ariaLabel: PropTypes.string,
  toggleLeadFormDrawer: PropTypes.func,
  btnClass: PropTypes.string,
  btnColor: PropTypes.string,
  icon: PropTypes.string,
  iconClass: PropTypes.string,
  titleClass: PropTypes.string,
  title: PropTypes.string,
};
